import React, { Component } from "react";
import { documents, documentsTitles,saved } from "./dynamic_documents";
class CompanyDocs extends Component {
  constructor(props) {
    super(props);
    this.refs = {
      companyDocsForm: React.createRef(),
    };
    props.initialconstruct.bind(this)("CompanyDocs");
    this.outerclass = "d-flex flex-wrap";
    this.passwordclass = "";
    this.state = {
      doclist: Object.entries(documents[props.firmType][props.documentKey])
    }
  }

  saved(key) {
    return saved(this,key)
  }

  validateDocuments(payload) {
    return Object.entries(payload).reduce((flag, [key, value]) => (flag && (isObject(value) ? !!value.attachment_id : true)), true);
  }

  getEditData() {
    let props = this.props;
    let { store } = props;
    let { credit: storeddata = {} } = store;
    return storeddata['remote']&&storeddata['remote'][props.documentKey];
  }

  saveDocInfo() {
    let editData = this.getEditData();
    let { doclist } = this.state;
    let data = this.refs.companyDocsForm.form.current.getData();

    let payload = doclist.reduce((o, [key, value]) => {
      return {
        ...o,
        [key]: {
          "attachment_id": data[`${key}`],
          "filename": data[`${key}_filename`],
          "password": data[`${key}_filepassword`],
          "status": "SUBMITTED"
        }
      }
    }, this.mixin.companyType()=='llp'?{
      remarks: data.remarks
    }:{});
    console.log({editData});
    if (this.validateDocuments(payload)) {
      let { props } = this;
      if (!!editData) {
        this.api.execApi("putCompanyDoc", payload, {
          firm_type: props.firmType
        }).then((response) => {
          alert("Info Updated Successfull.").promise.then(() => {
            this.props.onInfoList && this.props.onInfoList();
          });

        });
      } else {
        this.api.execApi("postCompanyDoc", payload, {
          firm_type: props.firmType
        }).then((response) => {
          alert("Info Updated Successfull.").promise.then(() => {
            this.props.onInfoList && this.props.onInfoList();
          });
        });
      }

    } else {
      alert("Please upload all above mentioned documents.");
    }
  }

  componentDidMount() {

    //console.log("Mounted");
  }



  uploadDocument(event, name, documentKey, offsetkey = "", offsetvalue = "") {
    let { props } = this;
    let input = event.target;
    let [file] = input.files;
    let docmeta = { name, group: "credit", firmType: props.firmType, documentKey: documentKey, offsetkey, [offsetkey || 'offsetvalue']: offsetvalue };
    let payload = {
      application_id: this.props.urlparams.application_id,
      file,
      doc_meta_name: JSON.stringify(docmeta).encode()
    };
    this.api.execApi("postDocument", payload, {}, {
      multipart:true, 
      message:"Uploading please wait...",
      onexec:() => {
        success("Upload Successfull").promise.then(() => {
          this.props.onFetchDocList && this.props.onFetchDocList();
        });
      }
    });
  }

  deleteDocument(args) {
    let payload = { attachment_id: args['data-invalue'] };
    this.api.execApi('deleteDocument', {}, payload).then(() => {
      this.props.onFetchDocList && this.props.onFetchDocList();
    });
  }

  downloadDocument(args) {
    let payload = { attachment_id: args['data-invalue'] };
    let url = this.api.getUrl('getDocument',payload);
    //console.log({url});
    window.open(url);
  }

  getFile(name, offsetkey = "", offsetvalue = "") {
    let { props } = this;
    let { docList: uploaded = {} } = props;
    let mydoclist = uploaded[props.documentKey] ?? [];
    return mydoclist.find(o => o.doc_meta_name.name == name && o.doc_meta_name[offsetkey || "offsetvalue"] == offsetvalue);
  }

  getFileAttrs(subkey) {
    let { props } = this;
    let file = this.getFile(subkey);
    return {
      "data-invalue": file?.attachment_id,
      "data-filename": file?.file_name,
      isuploaded: (!!file),
      labelname: file?.file_name
    }
  }

  storeFilePassword(e,key) {
    mixins.debounce(() => {
      this.store(`credit.state.${this.props.documentKey}.${key}.password`, e.target.value);
    });
  }

  setStateValue(key,value) {
    this.store(`credit.state.${this.props.documentKey}.${key}`, value);
  }

  handleInputEvent(e,key) {
    mixins.debounce(() => {
      this.setStateValue(key, e.target.value);
    })
  }

  render() {
    let { passwordclass, outerclass, state, props } = this;
    let { hasremarks = false, docList: uploaded = {}, edit = false, store } = props;
    let { credit: storeddata = {} } = store;
    let data = storeddata['remote']&&storeddata['remote'][props.documentKey] || {};
    let { doclist = [] } = state;
    return (
      <>
        <AppForm
          ref="companyDocsForm"
          id="companyDocsForm"
          onSubmit={() => this.saveDocInfo()}
        >
          {
            doclist.map(([key, field], i) => (<div className="row d-flex mb-3 g-3" key={key}>
            <label htmlFor={key} className="col-12 col-md-2 col-form-label">
              {documentsTitles[props.documentKey][key]}
            </label>
            <div className="col-12 col-md-6">
              <AppUploadPassword
                name={key}
                onPasswordChange={(v) => this.storeFilePassword(v,key)}
                password={this.saved(`${key}.password`)}
                passwordclass={passwordclass}
                outerclass={outerclass}
                editaccess="true"
                onChange={(e) => this.uploadDocument(e, key, props.documentKey)}
                onDelete={(...args) => this.deleteDocument(...args)}
                onDownload={(...args) => this.downloadDocument(...args)}
                defaultValue={""}
                {...this.getFileAttrs(key)}
              />
            </div>
            {
              (key == "cert_of_incoporation"  && storeddata.remarks && <AppInput
                name="remarks"
                className="col-12 col-md-12"
                type="text"
                placeholder="Enter Remarks"
                label="Remarks"
                defaultValue={this.saved(`remarks`)}
                onChange={(e)=>this.handleInputEvent(e,`remarks`)}
              />) || ""
            }

          </div>))
          }
          
          <div className="row d-flex">
            <div>
              <button
                className="btn add-btn text-dark rounded-pill ml-auto"
              >
                Update
              </button>
            </div>
          </div>
          <hr />
        </AppForm>
      </>
    );
  }
}

export default connect(CompanyDocs);